angular.module("app").controller("CasinoSettingsPageController", [
    '$scope',
    '$uibModal',
    'skinCasinoSetting',
    'casinoSettingService',
    'errorHandler',
    'logger',
    'userStorage',
    'toastr',
    function ($scope, $modal, skinCasinoSetting, casinoSettingService, errorHandler, logger, userStorage, toastr) {
        $scope.filterOptions = {
            skinId: null
        };

        if (!skinCasinoSetting) {
            return false;
        }

        $scope.hasPermission = userStorage.getUserData().permissions.indexOf('manageCasinoSettings') !== -1;
        $scope.hasAiOrderTestingPermission = userStorage.getUserData().permissions.indexOf('manageCasinoSettingAiOrderTesting') !== -1;

        $scope.skinCasinoSetting = angular.copy(skinCasinoSetting);
        $scope.skinCasinoSetting.game_auto_approve = !$scope.skinCasinoSetting.game_auto_approve
        $scope.skinCasinoSettingInitial = angular.copy($scope.skinCasinoSetting);

        $scope.saveCasinoSettings = function () {
            const updatedSettings = {};

            if ($scope.skinCasinoSetting.is_live != $scope.skinCasinoSettingInitial.is_live) {
                $scope.skinCasinoSettingInitial.is_live = $scope.skinCasinoSetting.is_live
                updatedSettings.is_live = +$scope.skinCasinoSetting.is_live
            }
            if ($scope.skinCasinoSetting.game_auto_approve != $scope.skinCasinoSettingInitial.game_auto_approve) {
                $scope.skinCasinoSettingInitial.game_auto_approve = $scope.skinCasinoSetting.game_auto_approve
                updatedSettings.game_auto_approve = +!$scope.skinCasinoSetting.game_auto_approve
            }
            if ($scope.skinCasinoSetting.allow_casino_ai_order != $scope.skinCasinoSettingInitial.allow_casino_ai_order) {
                $scope.skinCasinoSettingInitial.allow_casino_ai_order = $scope.skinCasinoSetting.allow_casino_ai_order
                updatedSettings.allow_casino_ai_order = +$scope.skinCasinoSetting.allow_casino_ai_order
            }
            if ($scope.skinCasinoSetting.allow_casino_ai_order_testing != $scope.skinCasinoSettingInitial.allow_casino_ai_order_testing) {
                $scope.skinCasinoSettingInitial.allow_casino_ai_order_testing = $scope.skinCasinoSetting.allow_casino_ai_order_testing
                updatedSettings.allow_casino_ai_order_testing = +$scope.skinCasinoSetting.allow_casino_ai_order_testing
            }

            if (!Object.keys(updatedSettings).length) {
                toastr.error("No changes are detected")
                return;
            }

            casinoSettingService.saveCasinoSetting({
                skinCasinoSetting: updatedSettings
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess('global.successfullyUpdated')
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            );
        };
    }
]);
